import { createAuthedApi } from '../../utils/authedApi'
import { userSchemas } from './schema'

export const profileApiCreator = authRequest => ({
  async getById(id) {
    const result = await authRequest(`/users/${id}`)

    return userSchemas.normalizeResponse(result)
  },
  async update(id, data) {
    const result = await authRequest(`/users/${id}`, {
      method: 'PUT',
      body: data
    })

    return userSchemas.normalizeResponse(result)
  },
  async updatePassword(id, data) {
    const result = await authRequest(`/users/${id}/password`, {
      method: 'PUT',
      body: data
    })

    return userSchemas.normalizeResponse(result)
  },
  async delete(id) {
    await authRequest(`/users/${id}`, {
      method: 'DELETE'
    })
  }
})

export default createAuthedApi(profileApiCreator)
